import { AuthGuard } from '@/modules/auth/router/auth.guard';

export default [
    {
        name: 'data-repository',
        path: '/data-repository',
        component: () => import(/* webpackChunkName: "sharing" */ '@/modules/sharing/views/DataRepository.vue'),
        meta: { title: 'Data Repository' },
        beforeEnter: AuthGuard,
    },
    {
        name: 'contracts',
        path: '/contracts',
        component: () => import(/* webpackChunkName: "sharing" */ '@/modules/sharing/views/Contracts.vue'),
        meta: { title: 'Contracts' },
        beforeEnter: AuthGuard,
    },
    {
        name: 'contract-details',
        path: '/contracts/:type/:id',
        component: () => import(/* webpackChunkName: "sharing" */ '@/modules/sharing/views/Contract.vue'),
        meta: { title: 'Contract' },
        props: true,
        beforeEnter: AuthGuard,
    },
    {
        name: 'contract-monitoring',
        path: '/contracts/:type/:id/monitoring',
        component: () => import(/* webpackChunkName: "sharing" */ '@/modules/sharing/views/ContractMonitoring.vue'),
        meta: { title: 'Contract Monitoring' },
        props: true,
        beforeEnter: AuthGuard,
    },
    {
        name: 'contract-action',
        path: '/contracts/:type/:id/:action',
        component: () => import(/* webpackChunkName: "sharing" */ '@/modules/sharing/views/Contract.vue'),
        meta: { title: 'Contract' },
        props: true,
        beforeEnter: AuthGuard,
    },
];
